export default "__VITE_ASSET__c3bf3a37__"